import React from 'react';
import EvaluationInvoiceView from '@fingo/lib/features/factoring/views/EvaluationInvoiceView';
import { OVERLAYS_MIN_HEIGHT } from '@fingo/lib/theme/constants/data-grid';
import {
  getColumns,
  INITIAL_ISSUED_DATE,
  HEADERS,
  BUTTONS_TO_SHOW,
} from '../../../../features/factoring/constants/evaluation-invoice';
import EvaluationInvoiceOverlay from '../../../../features/factoring/components/overlays/EvaluationInvoiceOverlay';

const EVALUATION_MOBILE_HEADERS = [
  'folio',
  'amountWithIva',
  'preoffer_Preofferevaluationrequest_Status',
];

const EvaluationInvoice = () => (
  <EvaluationInvoiceView
    getColumns={getColumns}
    includeHeaders={HEADERS}
    mobileHeaders={EVALUATION_MOBILE_HEADERS}
    buttonsToShow={BUTTONS_TO_SHOW}
    initialIssuedDate={INITIAL_ISSUED_DATE}
    gridMinHeight={OVERLAYS_MIN_HEIGHT}
    headerDescription="Sigue el avance de tus solicitudes de financiamiento."
    useBorderedTitle
    OverlayComponent={EvaluationInvoiceOverlay}
    shouldLoadNewInvoices={false}
  />
);

export default EvaluationInvoice;
